import { atom } from "recoil"

export const userStats = atom<{
    active: number | string;
    pendingAccount: number | string;
    deactivated: number | string;
}>({
    key: "userStats",
    default: {
        active: 0,
        pendingAccount: 0,
        deactivated: 0,
    },
})
